/* =========================================
   Sticky Add to Cart Bar — JavaScript
   Vanilla JS, IntersectionObserver, AJAX Cart
   ========================================= */

(function () {
  'use strict';

  const bar = document.querySelector('.sticky-atc');
  if (!bar) return;

  const btn = bar.querySelector('.sticky-atc__btn');
  const btnText = bar.querySelector('.sticky-atc__btn-text');
  const priceEl = bar.querySelector('.sticky-atc__price');
  const variantInput = bar.querySelector('[name="sticky-variant-id"]');
  const defaultLabel = btn?.dataset.label || 'Add To Cart';
  const soldOutLabel = btn?.dataset.soldout || 'Sold Out';
  let variantAvailable = !!btn && !btn.disabled;

  /* ---- TimesAct "Notify me" variants ---- */
  // The TimesAct app (assets/timesact.js) hides the main Add to cart button of a variant set to "Notify me"
  // (back in stock) and shows its own "Sign Up To Be Notified" button in its place. The bar follows it: the
  // app's label, and the click opens the app's sign-up form instead of adding to the cart.
  function notifyButton() {
    var button = document.querySelector(
      'product-info[id^="MainProduct-"]:not([data-original-section]) .timesact-button-bis'
    );
    // Or the main button itself, once assets/timesact-notify.js has taken its form over (the app was too slow)
    if (!button || !button.getClientRects().length) {
      var form = guardedMainForm();
      button = form && form.dataset.timesactNotify ? form.querySelector('[type="submit"]') : null;
    }
    return button && button.getClientRects().length ? button : null;
  }

  var notifying = false;
  function syncNotify() {
    if (!btn) return;
    var notify = notifyButton();
    if (notify) {
      notifying = true;
      bar.classList.add('sticky-atc--notify');
      btn.disabled = false;
      var text = notify.textContent.trim();
      if (btnText.textContent !== text) btnText.textContent = text;
    } else if (notifying) {
      // A variant that can be added again
      notifying = false;
      bar.classList.remove('sticky-atc--notify');
      btn.disabled = !variantAvailable;
      btnText.textContent = variantAvailable ? defaultLabel : soldOutLabel;
    }
  }

  /* ---- Scroll detection via IntersectionObserver ---- */
  function initObserver() {
    // BFCM sale design: show the bar once the main Add to cart button has scrolled above the screen.
    // Checked on scroll and resize rather than with an IntersectionObserver, which misses jumps straight
    // past the button (End/Home keys, restored scroll, anchor links without smooth scrolling). The button is
    // looked up each time, so a section re-rendered in the theme editor keeps working.
    if (bar.dataset.showAfter === 'add-to-cart') {
      var shown = null;
      var queued = false;
      var update = function () {
        queued = false;
        // The bar was removed or re-rendered (theme editor): stop, and take its bottom room away
        if (!bar.isConnected) {
          window.removeEventListener('scroll', queue);
          window.removeEventListener('resize', queue);
          if (!document.querySelector('.sticky-atc--bfcm')) document.body.classList.remove('sticky-atc-on');
          return;
        }
        // On a "Notify me" variant TimesAct's button takes the hidden Add to cart button's place
        var mainButton =
          notifyButton() ||
          document.querySelector(
            'product-info[id^="MainProduct-"]:not([data-original-section]) [id^="ProductSubmitButton-"]'
          );
        var rect = mainButton && mainButton.getBoundingClientRect();
        // A hidden or missing button (height 0) never shows the bar
        var show = !!rect && rect.height > 0 && rect.bottom < 0;
        if (show === shown) return;
        shown = show;
        bar.classList.toggle('sticky-atc--hidden', !show);
        // Not focusable or announced while it's off screen
        bar.inert = !show;
        // Room at the bottom of the page, so the bar never covers the footer
        document.body.classList.toggle('sticky-atc-on', show);
      };
      var queue = function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(update);
      };
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      update();
      return;
    }

    // Watch the product info section — show sticky bar after scrolling past it
    var target = document.querySelector('.product__info-wrapper');
    if (!target) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            bar.classList.add('sticky-atc--hidden');
          } else {
            bar.classList.remove('sticky-atc--hidden');
          }
        });
      },
      { threshold: 0, rootMargin: '0px' }
    );

    observer.observe(target);
  }

  /* ---- Variant sync ---- */
  function getMainVariantId() {
    // Read from the main product form's hidden input
    var input = document.querySelector('product-form input[name="id"], .product-form input[name="id"]');
    return input ? input.value : null;
  }

  function updateVariant(variant) {
    if (!variant) return;

    variantInput.value = variant.id;

    // Update price
    if (priceEl && variant.price != null) {
      priceEl.textContent = formatMoney(variant.price);
    }

    // Update availability
    variantAvailable = variant.available;
    if (variant.available) {
      btn.disabled = false;
      btnText.textContent = defaultLabel;
    } else {
      btn.disabled = true;
      btnText.textContent = soldOutLabel;
    }
    if (notifying) syncNotify();
  }

  function formatMoney(cents) {
    // Simple money format — respects Shopify's default USD format
    var amount = (cents / 100).toFixed(2);
    return '$' + amount;
  }

  // BFCM sale design: the new variant's sale price and savings, rendered by Shopify for every variant in the
  // bar's template (sections/sticky-atc.liquid), so they don't depend on the product section's settings
  function updateSalePrice(variantId) {
    var source = bar.querySelector('template[data-sticky-sale-variants]');
    var entry = source && source.content.querySelector('[data-variant-id="' + variantId + '"]');
    if (!entry) return;
    var price = bar.querySelector('[data-sticky-sale-price] .bfcm-price');
    var freshPrice = entry.querySelector('.bfcm-price');
    if (price && freshPrice) price.replaceWith(freshPrice.cloneNode(true));
    var save = bar.querySelector('[data-sticky-save]');
    var freshSave = entry.querySelector('[data-save]');
    if (save && freshSave) save.innerHTML = freshSave.innerHTML;
  }

  // Variant changes in another product's quick-add window (e.g. related products) carry the same section
  // id; they must not change this page's bar
  function isOtherProduct(html) {
    var page = document.querySelector('product-info[id^="MainProduct-"]:not([data-original-section])');
    var fresh = html && html.querySelector('product-info[data-product-id]');
    return !!(page && fresh && page.dataset.productId && fresh.dataset.productId !== page.dataset.productId);
  }

  // Listen to Dawn's pub-sub variant-change event
  if (typeof subscribe === 'function') {
    subscribe('variant-change', function (event) {
      var variant = event?.data?.variant;
      if (variant && !isOtherProduct(event.data.html)) {
        updateVariant(variant);
        if (bar.classList.contains('sticky-atc--bfcm')) updateSalePrice(variant.id);
      }
    });
  }

  /* ---- AJAX Add to Cart (with cart drawer support) ---- */
  function addToCart() {
    var variantId = variantInput.value || getMainVariantId();
    if (!variantId || btn.disabled) return;

    // Loading state
    btn.classList.add('sticky-atc__btn--loading');
    btn.disabled = true;

    // Find the cart drawer/notification element (same lookup as product-form.js)
    var cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    // Build form data exactly like Dawn's product-form.js
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cartDrawer.getSectionsToRender().map(function (section) { return section.id; })
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cartDrawer.setActiveElement === 'function') {
        cartDrawer.setActiveElement(document.activeElement);
      }
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript',
      },
      body: formData,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        // Check for error response from Shopify
        if (response.status) {
          throw new Error(response.description || 'Could not add to cart');
        }

        // Success state
        btn.classList.remove('sticky-atc__btn--loading');
        btn.disabled = false;
        btnText.textContent = 'Added \u2713';

        // If no cart drawer, redirect to cart page (same as product-form.js)
        if (!cartDrawer) {
          window.location = window.routes.cart_url;
          return;
        }

        // Remove is-empty class from cart drawer
        if (cartDrawer.classList.contains('is-empty')) {
          cartDrawer.classList.remove('is-empty');
        }

        // Publish cartUpdate event for Dawn components (before rendering)
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: variantId,
            cartData: response,
          });
        }

        // Open the cart drawer with rendered sections from the response
        if (typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(response);
        }

        // Reset button text after 2 seconds (unless a "Notify me" variant was chosen meanwhile)
        setTimeout(function () {
          if (!notifying) btnText.textContent = defaultLabel;
        }, 2000);
      })
      .catch(function () {
        btn.classList.remove('sticky-atc__btn--loading');
        btn.disabled = false;
        btnText.textContent = defaultLabel;
      });
  }

  /* ---- Event listeners ---- */
  if (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var notify = notifyButton();
      if (notify) {
        notify.click();
        return;
      }
      // A "Notify me" product before TimesAct has shown its button: assets/timesact-notify.js blocks the main
      // form's submit and opens the app's form once it can
      var guarded = guardedMainForm();
      if (guarded) {
        if (guarded.requestSubmit) guarded.requestSubmit();
        else guarded.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        return;
      }
      addToCart();
    });
  }

  function guardedMainForm() {
    var main = document.querySelector('product-info[id^="MainProduct-"]:not([data-original-section])');
    if (!main) return null;
    var forms = main.querySelectorAll('form[data-timesact-notify-guard]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].closest('[data-product-id]') === main) return forms[i];
    }
    return null;
  }

  /* ---- Init ---- */
  initObserver();

  // TimesAct adds its button once its settings have loaded and shows or hides it on variant changes
  var productInfo = document.querySelector('product-info[id^="MainProduct-"]:not([data-original-section])');
  if (productInfo && btn) {
    var syncQueued = false;
    new MutationObserver(function () {
      if (syncQueued) return;
      syncQueued = true;
      requestAnimationFrame(function () {
        syncQueued = false;
        syncNotify();
      });
    }).observe(productInfo, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    syncNotify();
  }
})();
